export default __webpack_public_path__ + "static/media/real-state.1a54e514.jpg";